import React, { Component, Fragment, useState, useEffect } from 'react';
import QuantitySelector from '../QuantitySelector';
import ProductPrice from '../ProductPrice';
import Checkbox from '../Checkbox';
import BuyBox from './BuyBox';
import { translate } from '../../Services/translation';
import LightboxImagesAccessories from '../LightboxImagesAccessories';
import { pushAddToCartEvent } from "../../Actions/Gtm.action";
import { culture } from '../../Services/culture';
import { currency } from '../../Services/currency';
import { useDispatch } from 'react-redux';
import { load as loadCart, hint as hintCart } from '../../Actions/Cart.action';

const BuySection = (props) => {
    const dispatch = useDispatch();
    let superBuilderHasData = props.superBuilder != null && props.superBuilder != "";
    let superBuilder = superBuilderHasData ? JSON.parse(props.superBuilder) : null;
    let superBuilderHasSections = superBuilderHasData ? JSON.parse(props.superBuilder).sections.length > 0 : false;
    let unitPrice = props.campaignPrice > 0 ? props.campaignPrice : props.price;

    const [anyAccessorySelected, setanyAccessorySelected] = useState(false);
    const [quantity, setquantity] = useState(props.packagingQuantity);
    const [activeAccessory, setactiveAccessory] = useState(null);
    const [originalPrice, setoriginalPrice] = useState(superBuilderHasSections ? 0 : props.price);
    const [unitPriceData, setunitPriceData] = useState(superBuilderHasSections ? 0 : unitPrice);
    const [packagingQuantity, setpackagingQuantity] = useState(props.packagingQuantity);
    const [accessoryList, setaccessoryList] = useState([]);
    const [updateState, setupdateState] = useState(false);


    const formatter = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });


    useEffect(() => {
        stickyBuyboxObserver();
        setaccessoryList(getAccessoryList(props.accessories));
    }, []);

    useEffect(() => {
        let superBuilderPrices = superBuilderHasSections ? getSuperBuilderStandardPriceTotal(props) : null;

        let price = superBuilderHasSections ? superBuilderPrices.price : props.price;
        let campaignPrice = superBuilderHasSections ? superBuilderPrices.campaignPrice : props.campaignPrice;

        setaccessoryList(getAccessoryList(props.accessories));
        setoriginalPrice(price);
        setunitPriceData(campaignPrice > 0 ? campaignPrice : price);
        setpackagingQuantity(props.packagingQuantity);
    }, [props]);


    const getSuperBuilderStandardPriceTotal = (props) => {
        var total = {
            price: 0,
            campaignPrice: 0
        };

        var superBuilder = JSON.parse(props.superBuilder);
        superBuilder.sections.forEach(s => s.variants.forEach((v) => {
            superBuilder.selectedCombinedKeys.filter(keys => {
                if (v.key == keys.key) {
                    total.price += v.price * keys.quantity;
                    total.campaignPrice += v.campaignPrice * keys.quantity;
                }
            });
        }));

        return total;
    }

    const updateQuantity = (articleNumber, adjust) => {
        let newQuantity = quantity + adjust;

        if (newQuantity < 1) {
            newQuantity = packagingQuantity;
        }

        setquantity(newQuantity);
    }

    const onAccessoryClick = (item) => {
        setactiveAccessory(item);
    }


    const stickyBuyboxObserver = () => {
        if (!!window.IntersectionObserver) {
            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    var buyContainer = document.getElementsByClassName("buy-box__main");
                    if (buyContainer.length) {
                        if (entry.boundingClientRect.bottom < entry.rootBounds.bottom) {
                            buyContainer[0].classList.add("anim-hide");
                        } else {
                            buyContainer[0].classList.remove("anim-hide");
                        }
                    }
                });
            }, {
                rootMargin: "100% 0px 0px 0px",
                threshold: 1
            }
            );
            document.querySelectorAll('.js-product-info').forEach(item => { observer.observe(item) });
        }
    }

    const buy = () => {
        if (superBuilderHasSections) {
            buySuperBuilder();
            return;
        }
        let items = [{
            article: props.article,
            quantity: quantity
        }];

        accessoryList.forEach(accessory => {
            if (accessory.active) {
                items.push({
                    Article: accessory.id,
                    Quantity: accessory.quantity
                })
            }
        });

        fetch('/api/cart/addarticles', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify(items),
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                dispatch(loadCart(result));                
                if (items[0]) {
                    dispatch(hintCart(items[0].article));
                    dispatch(pushAddToCartEvent(items, true));
                }
            })
            .catch(error => console.log('error', error));
    }

    const buySuperBuilder = () => {
        let order = {
            parentid: props.parent,
            articles: [],
            rowItems: [],
            isSuperBuilder: true
        }
        var superBuilder = JSON.parse(superBuilder);
        let selectedCombinedKeys = superBuilder.selectedCombinedKeys;
        for (var i = 0; i < selectedCombinedKeys.length; i++) {
            order.articles.push({
                articleNumber: getArticleNumber(superBuilder, selectedCombinedKeys[i].key),
                quantity: selectedCombinedKeys[i].quantity * quantity,
                isAccessory: false,
                superBuilderKey: selectedCombinedKeys[i].key,
                isMandatory: selectedCombinedKeys[i].isMandatory,
                isMaximumOfOneAllowed: selectedCombinedKeys[i].isMaximumOfOneAllowed
            });
        }

        // Add to cart
        fetch("/api/cart/addconfiguredarticle", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify(order),
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                dispatch(loadCart(result));
                if (order.articles[0]) {
                    dispatch(hintCart(items[0].article));
                    dispatch(pushAddToCartEvent(order.articles, false));
                }
            })
            .catch(error => console.log('error', error));
    }

    const getArticleNumber = (superBuilder, key) => {
        var articleNumber = "";
        superBuilder.sections.forEach(s => s.variants.forEach(v => {
            if (v.key == key) {
                articleNumber = v.articleNumber;
            }
        }))

        return articleNumber;
    }

    const getTotalPrice = (useFullPrices, packagingQuantity) => {
        let price = (useFullPrices ? originalPrice : unitPriceData) * (quantity);

        accessoryList.forEach(accessory => {
            let accessoryPrice = useFullPrices ? accessory.originalPrice : accessory.price;

            if (accessory.active) {
                price += (accessoryPrice * accessory.quantity);
            }
        });

        return price;
    }

    const updateAccessoryQuantity = (articleNumber, quantityChange) => {
        accessoryList.forEach(accessory => {
            if (accessory.id === articleNumber) {
                let newQuantity = accessory.quantity += quantityChange;

                if (newQuantity < 0) {
                    newQuantity = 0;
                }

                accessory.active = (newQuantity > 0);
                accessory.quantity = newQuantity;

                setanyAccessorySelected(accessoryList.some(a => a.active)); 
                setupdateState(!updateState);               
            }
        });
    }

    const toggleAccessory = (articleNumber, isChecked) => {
        accessoryList.forEach(accessory => {
            if (accessory.id === articleNumber) {
                accessory.active = isChecked;

                if (accessory.active && accessory.quantity === 0) {
                    accessory.quantity = 1;
                }

                setanyAccessorySelected(accessoryList.some(a => a.active));    
                setupdateState(!updateState);            
            }
        });
    }

    const getAccessoryList = (accessoryData) => {
        let list = [];

        accessoryData.forEach(accessory => {
            list.push({
                id: accessory.id,
                name: accessory.name,
                imageData: accessory.imageData,
                price: (accessory.decimalCampaignPrice && accessory.decimalCampaignPrice < accessory.decimalPrice) ? accessory.decimalCampaignPrice : accessory.decimalPrice,
                originalPrice: accessory.decimalPrice,
                quantity: 0,
                active: false,
                packagingQuantity: accessory.packagingQuantity
            });
        });

        return list;
    }

    return (
        <Fragment>
            {props.bundleProducts.length > 0 &&
                <ul className="product-selector">
                    <li>
                        <div className="product-selector__header">
                            <div className='section-status'>
                            </div>
                            <div className="product-selector__name summary">
                                <span>{translate('bundleproducts.header')}</span>
                            </div>
                        </div>
                        <div className="product-selector__content bundle-section">
                            <div className="product-selector__selected-options">
                                <ul className="product-selector__selected-options-list">
                                    {props.bundleProducts.map((bundleproduct, index) => {
                                        return <li key={index} className="product-selector__selected-option">
                                            <a href={bundleproduct.url}>{bundleproduct.quantity} x {bundleproduct.name}</a>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            }
            {accessoryList.length > 0 &&
                <ul className="product-selector">
                    <li>
                        <div className="product-selector__header">
                            <div className={'section-status' + (anyAccessorySelected ? ' section-status--done' : '')}>
                                {anyAccessorySelected &&
                                    <svg>
                                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                                    </svg>
                                }
                            </div>
                            <div className="product-selector__name">
                                <span>{props.title}</span>
                            </div>
                        </div>
                        <div className="product-selector__content">
                            <ul className="accessory-list">
                                {accessoryList.map((accessory, index) => {
                                    return <li key={`accessory-${accessory.id}-${index}`}>
                                        <div className={'image-container contain' + (accessory.img ? '' : ' dummy-image')}>
                                            {accessory && accessory.imageData && accessory.imageData.src && <a data-src={accessory.imageData.src} itemProp="url" className="product-image" onClick={() => onAccessoryClick(accessory.imageData)}>
                                                <img className="product-detail__image--main" itemProp="image" src={accessory.imageData.thumbnail} />
                                            </a>
                                            }
                                        </div>
                                        <div className="accessory-list__content">
                                            <Checkbox isChecked={accessory.active} onClick={toggleAccessory} isSmall={true}
                                                value={accessory.id}></Checkbox>
                                            <div className="accessory-list__name">
                                                <span>{accessory.name}</span>
                                            </div>
                                            <ProductPrice
                                                formatter={formatter}
                                                campaignPrice={accessory.price}
                                                price={accessory.originalPrice}
                                                packagingQuantity={accessory.packagingQuantity}
                                                quantity={accessory.quantity}
                                            ></ProductPrice>
                                            <QuantitySelector isSmall={true} quantity={accessory.quantity} articleNumber={accessory.id} 
                                            packagingQuantity={accessory.packagingQuantity}
                                                onChange={updateAccessoryQuantity}></QuantitySelector>
                                        </div>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </li>
                </ul>
            }
            {activeAccessory &&
                <LightboxImagesAccessories images={activeAccessory} onClick={onAccessoryClick} />
            }
            <BuyBox buy={buy}
                totalPrice={getTotalPrice(false, packagingQuantity)}
                quantity={quantity}
                articleNumber={props.articleNumber}
                currentPrice={unitPriceData}
                originalPrice={getTotalPrice(true, packagingQuantity)}
                updateQuantity={updateQuantity}
                comment={props.comment}
                stockInfoMessage={props.stockInfoMessage}
                stockstatus={props.stockstatus}
                formatter={formatter}
                enabled={true}
                packagingQuantity={packagingQuantity}
                productInfoMessage={props.productInfoMessage}
                featureList={props.featureList}></BuyBox>
        </Fragment>);
}

export default BuySection;
